









































import Vue from 'vue'

import MultipleUnitsTooltip from '@/common/components/MultipleUnitsTooltip.vue'

export default Vue.extend({
  components: {
    MultipleUnitsTooltip
  },
  data(): {
    showMultipleUnits: boolean
  } {
    return {
      showMultipleUnits: false
    }
  },
  computed: {
    quantities() {
      return this.$store.getters.quantities
    },
    hasMultipleUnits() {
      return this.quantities.units.length > 1
    }
  },
  methods: {
    showMultipleUnitsModal() {
      this.showMultipleUnits = true
    },
    hideMultipleUnitsModal() {
      this.showMultipleUnits = false
    }
  }
})
